function Header() {
  return (
    <>
      <header className="header">
        {/* LOGO */}
        <div className="logo-container">
          <img
            src="/logo.png"   // ← replace later
            alt="MomenQ Logo"
            className="logo-image"
          />
        </div>

        {/* Desktop Navigation */}
        {/* <nav className="nav-desktop">
          <a href="#about">About</a>
          <a href="#packages">Packages</a>
          <a href="#skills">Skills</a>
          <a href="#contact">Contact</a>
        </nav> */}

        {/* Mobile Menu Icon */}
        {/* <div className="menu-icon" onClick={() => setIsOpen(true)}>
          <FaBars />
        </div> */}
      </header>

      {/* Sidebar */}
      {/* <div className={`sidebar ${isOpen ? "open" : ""}`}>
        <div className="close-icon" onClick={() => setIsOpen(false)}>
          <FaTimes />
        </div>

        <a href="#about" onClick={() => setIsOpen(false)}>About</a>
        <a href="#projects" onClick={() => setIsOpen(false)}>Projects</a>
        <a href="#skills" onClick={() => setIsOpen(false)}>Skills</a>
        <a href="#contact" onClick={() => setIsOpen(false)}>Contact</a>
      </div> */}

      {/* Overlay */}
      {/* {isOpen && <div className="overlay" onClick={() => setIsOpen(false)} />} */}
    </>
  );
}

export default Header;
